// TODO Would be nice to export boolean instead of the function but I didn't find a way to control it when testing dependant modules

import window from '@atlas/tool/box/browser/window';

const _isApplePlatform = window ? testUserAgent(window.navigator.userAgent) : false;

export default function isApplePlatform(): boolean {
    return _isApplePlatform;
}

// #region Helpers

function testUserAgent(userAgent: string): boolean {
    return /Mac|iPhone/i.test(userAgent);
}

// #endregion

// #region Tests

if (import.meta.vitest) {
    const { describe, it, expect } = import.meta.vitest;
    describe('isApplePlatform', () => {
        it('results to true when userAgent is set by Macintosh', () => {
            const apple = testUserAgent(
                'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/114.0.0.0 Safari/537.36',
            );
            expect(apple).toBe(true);
        });

        it('results to true when userAgent is set by iOS', () => {
            const apple = testUserAgent(
                'Mozilla/5.0 (iPhone13,2; U; CPU iPhone OS 14_0 like Mac OS X) AppleWebKit/602.1.50 (KHTML, like Gecko) Version/10.0 Mobile/15E148 Safari/602.1',
            );
            expect(apple).toBe(true);
        });

        it('results to false when userAgent is set by Windows', () => {
            const apple = testUserAgent(
                'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/42.0.2311.135 Safari/537.36 Edge/12.246',
            );
            expect(apple).toBe(false);
        });

        it('results to false when userAgent is set by Linux', () => {
            const apple = testUserAgent(
                'Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:15.0) Gecko/20100101 Firefox/15.0.1',
            );
            expect(apple).toBe(false);
        });

        it('results to false when userAgent is set by Android', () => {
            const apple = testUserAgent(
                'Mozilla/5.0 (Linux; Android 13; SM-S901B) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/112.0.0.0 Mobile Safari/537.36',
            );
            expect(apple).toBe(false);
        });
    });
}

// #endregion
